import router from '@/router/router'
import { routeList } from '@/router/helpers/routes'
import { saveRouteParams } from '@/store/helpers/accessControl'

/** get all application routes mapped in our router
@return { Array }
*/
export const getAllAuthenticatedRoutes = () => {
	const authenticatedRoutes = router.options.routes.find(obj => obj.name === routeList.AUTHENTICATED_BASE_NAME)
    return authenticatedRoutes.children.map(obj => { return obj.path })
}

/** navigates to the passed route with the passed params
@routeName { string } - name of the route
@params { object } params to pass to the route
@return { void }
*/
export const navigateByName = (routeName, params) => {
    saveRouteParams(params)
    router.push({ name: routeName })
}

/** navigates to the passed route by path
@path { string } - path
@return { void }
*/
export const navigateByPath = path => {
    router.push(path)
}

/** replaces the current route location
@path { string } - path
@return { void }
*/
export const replacePath = path => {
    router.replace({ path: path })
}

/** replaces the current route hash location
@path { string } - path
@return { void }
*/
export const replaceHash = hash => {
    router.replace({ hash: `#${hash}` })
}

/** goes back to the last route
@return { void }
*/
export const navigateBack = () => {
    router.go(-1)
}
